import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=5778c77e&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=ts"
export * from "./Notices.vue?vue&type=script&lang=ts"
import style0 from "./Notices.vue?vue&type=style&index=0&id=5778c77e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5778c77e",
  null
  
)

export default component.exports